import React from 'react'
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';
import {  FormControlLabel, FormGroup, Grid } from '@mui/material';


const AntSwitch = styled((props) => (
    <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
  ))(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    '& .MuiSwitch-switchBase': {
      padding: 0,
      margin: 2,
      transitionDuration: '300ms',
      '&.Mui-checked': {
        transform: 'translateX(16px)',
        color: '#fff',
        '& + .MuiSwitch-track': {
          backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : 'rgb(30,60,114)',
          opacity: 1,
          border: 0,
        },
        '&.Mui-disabled + .MuiSwitch-track': {
          opacity: 0.5,
        },
      },
      '&.Mui-focusVisible .MuiSwitch-thumb': {
        color: '#33cf4d',
        border: '6px solid #fff',
      },
      '&.Mui-disabled .MuiSwitch-thumb': {
        color:
          theme.palette.mode === 'light'
            ? theme.palette.grey[100]
            : theme.palette.grey[600],
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
      },
    },
    '& .MuiSwitch-thumb': {
      boxSizing: 'border-box',
      width: 22,
      height: 22,
    },
    '& .MuiSwitch-track': {
      borderRadius: 26 / 2,
      backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : '#39393D',
      opacity: 1,
      transition: theme.transitions.create(['background-color'], {
        duration: 500,
      }),
    },
  }));

const PermissionModal = ({open,handlePermissionDialogClose,updatedPermissionList,handleSaveData,handleSwitchChange}) => {
  return (
    <Dialog fullWidth maxWidth="sm" open={open}>
        <DialogTitle>User Permissions</DialogTitle>
            <DialogContent dividers> 
                <Grid container sx={{display: 'flex', justifyContent: 'space-between'}}>
                    <FormGroup sx={{pl:1,pt:1}}>
                        {updatedPermissionList?.map((permission,index) => {
                        return (
                        <FormControlLabel key={index} sx={{pb:1.5}} value={index}  control={ 
                            <><AntSwitch
                                key={permission.id}
                                checked={permission.checked}
                                onChange={handleSwitchChange(permission.id)}
                                value={permission.id || ''}
                                inputProps={{ 'aria-label': 'controlled' }} />
                                <label style={{paddingLeft:'16px'}}>{permission.permission_name}</label>
                                </>
                            } />
                            )
                        })}
                    </FormGroup> 
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button  
                    variant="contained"
                    size="medium"
                    color="primary" 
                    onClick={handleSaveData}
                >Submit</Button>
                <Button  
                    variant="contained"
                    size="medium"
                    color="error" 
                    onClick={handlePermissionDialogClose}
                >Cancel</Button>
            </DialogActions>
        </Dialog> 
  )
}

export default PermissionModal